import { render, staticRenderFns } from "./NovosFornecedoresAnoDash.vue?vue&type=template&id=5e2a68f4&"
import script from "./NovosFornecedoresAnoDash.vue?vue&type=script&lang=js&"
export * from "./NovosFornecedoresAnoDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports